module.exports = __webpack_public_path__ + "img/9-1.fb62bbc7.png";